import { render, staticRenderFns } from "./businessEntitySettings.vue?vue&type=template&id=36c40feb&scoped=true"
import script from "./businessEntitySettings.vue?vue&type=script&lang=js"
export * from "./businessEntitySettings.vue?vue&type=script&lang=js"
import style0 from "./businessEntitySettings.vue?vue&type=style&index=0&id=36c40feb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c40feb",
  null
  
)

export default component.exports